import React from 'react';
import heroImage from '../assets/hero-farzeen.png';

const ThemeSamples = () => {
  return (
    <div>
      {/* DARK THEME SAMPLE */}
      <section className="min-h-screen relative" style={{ backgroundColor: '#0a0a0a' }}>
        {/* Navigation - Dark */}
        <nav className="absolute top-0 left-0 right-0 z-50 py-6 px-8">
          <div className="container mx-auto flex items-center justify-between">
            <span className="text-white text-sm tracking-[0.3em] font-light">FARZEEN</span>
            <div className="hidden md:flex items-center gap-12">
              <a href="#" className="text-white/70 hover:text-white text-xs tracking-[0.2em] font-light transition-colors">HOME</a>
              <a href="#" className="text-white/70 hover:text-white text-xs tracking-[0.2em] font-light transition-colors">ABOUT</a>
              <a href="#" className="text-white/70 hover:text-white text-xs tracking-[0.2em] font-light transition-colors">SERVICES</a>
              <a href="#" className="text-white/70 hover:text-white text-xs tracking-[0.2em] font-light transition-colors">CONTACT</a>
            </div>
            <a href="#" className="text-white/70 hover:text-white text-xs tracking-[0.2em] font-light">BOOK A CALL</a>
          </div>
        </nav>

        <div className="container mx-auto px-8 min-h-screen flex items-center">
          <div className="grid md:grid-cols-2 gap-12 items-center w-full">
            {/* Left - Text */}
            <div className="order-2 md:order-1">
              <p className="text-white/50 text-xs tracking-[0.3em] mb-6 font-light">DIGITAL MARKETING MENTOR</p>
              <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
                BREAK FREE.
                <br />
                <span className="italic">Build Online.</span>
                <br />
                LIVE ON YOUR TERMS.
              </h1>
              <p className="text-white/60 text-base font-light leading-relaxed mb-10 max-w-md">
                Empowering women to build freedom-based businesses through digital marketing and personal branding.
              </p>
              <a 
                href="#" 
                className="inline-block border border-white/30 text-white text-xs tracking-[0.2em] px-10 py-4 hover:bg-white hover:text-black transition-all duration-300"
              >
                START YOUR JOURNEY
              </a>
            </div>
            
            {/* Right - Image */}
            <div className="order-1 md:order-2">
              <img 
                src={heroImage} 
                alt="Farzeen" 
                className="w-full h-[70vh] object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Label */}
        <div className="absolute bottom-8 left-8">
          <p className="text-white text-2xl font-bold">⬆️ DARK THEME</p>
        </div>
      </section>

      {/* Divider */}
      <div className="h-4 bg-red-500 flex items-center justify-center">
        <span className="text-white font-bold text-xl">↓ SCROLL DOWN FOR NEUTRAL THEME ↓</span>
      </div>

      {/* NEUTRAL/LIGHT PREMIUM THEME SAMPLE */}
      <section className="min-h-screen relative" style={{ backgroundColor: '#f8f6f3' }}>
        {/* Navigation - Light */}
        <nav className="absolute top-0 left-0 right-0 z-50 py-6 px-8">
          <div className="container mx-auto flex items-center justify-between">
            <span className="text-sm tracking-[0.3em] font-light" style={{ color: '#1a1a1a' }}>FARZEEN</span>
            <div className="hidden md:flex items-center gap-12">
              <a href="#" className="text-xs tracking-[0.2em] font-light transition-colors hover:opacity-60" style={{ color: '#1a1a1a' }}>HOME</a>
              <a href="#" className="text-xs tracking-[0.2em] font-light transition-colors hover:opacity-60" style={{ color: '#1a1a1a' }}>ABOUT</a>
              <a href="#" className="text-xs tracking-[0.2em] font-light transition-colors hover:opacity-60" style={{ color: '#1a1a1a' }}>SERVICES</a>
              <a href="#" className="text-xs tracking-[0.2em] font-light transition-colors hover:opacity-60" style={{ color: '#1a1a1a' }}>CONTACT</a>
            </div>
            <a href="#" className="text-xs tracking-[0.2em] font-light hover:opacity-60" style={{ color: '#1a1a1a' }}>BOOK A CALL</a>
          </div>
        </nav>

        <div className="container mx-auto px-8 min-h-screen flex items-center">
          <div className="grid md:grid-cols-2 gap-12 items-center w-full">
            {/* Left - Text */}
            <div className="order-2 md:order-1">
              <p className="text-xs tracking-[0.3em] mb-6 font-light" style={{ color: '#8b7355' }}>DIGITAL MARKETING MENTOR</p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-8" style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}>
                BREAK FREE.
                <br />
                <span className="italic" style={{ color: '#8b7355' }}>Build Online.</span>
                <br />
                LIVE ON YOUR TERMS.
              </h1>
              <p className="text-base font-light leading-relaxed mb-10 max-w-md" style={{ color: '#666' }}>
                Empowering women to build freedom-based businesses through digital marketing and personal branding.
              </p>
              <a 
                href="#" 
                className="inline-block border text-xs tracking-[0.2em] px-10 py-4 transition-all duration-300"
                style={{ borderColor: '#1a1a1a', color: '#1a1a1a' }}
                onMouseOver={(e) => { e.target.style.backgroundColor = '#1a1a1a'; e.target.style.color = 'white'; }}
                onMouseOut={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#1a1a1a'; }}
              >
                START YOUR JOURNEY
              </a>
            </div>
            
            {/* Right - Image */}
            <div className="order-1 md:order-2">
              <img 
                src={heroImage} 
                alt="Farzeen" 
                className="w-full h-[70vh] object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Label */}
        <div className="absolute bottom-8 left-8">
          <p className="text-2xl font-bold" style={{ color: '#1a1a1a' }}>⬆️ NEUTRAL/LIGHT PREMIUM THEME</p>
        </div>
      </section>
    </div>
  );
};

export default ThemeSamples;
